import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, ViewRef} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormBuilder, FormGroup, FormsModule} from "@angular/forms";
import {FileUploader, FileUploaderOptions} from "ng2-file-upload";
import {SwitchBoard} from "../../../services/SwitchBoard";
import {TpFirmTodoService} from "../../../tpiq-services/tp-firm-todo.service";
import {TasksService} from "../../../services/Tasks.service";
import {LoadingService} from "../../../services/LoadingService";
import {ActivatedRoute, Router} from "@angular/router";
import {ManageTaxStrategiesServices} from "../../../tpiq-services/manage-tax-strategies.service";
import {takeUntil} from "rxjs/operators";
import {CollaborationService} from "../../../services/Collaboration.service";
import {ToastService} from "../../../services/Toast.service";
import {StateService} from "../../../services/StateService";
import {NgxScrollEvent} from "../../../directives/ngx-scroll-event.directive";
import {DateFormater} from "../../../services/DateFormatter.service";
import {TOAST_TYPE} from "../../../constants/Tpiq.constants";
import {State} from "../../../models/State";
import {Session} from "../../../services/Session";
import {TrackerPaginatedTableComponent} from "../../../tables/tracker-paginated-table/tracker-paginated-table.component";
import {PageTitleService} from "../../../services/PageTitle";
import {v4 as uuid} from 'uuid';
import {TodoServices} from "../../../services/todos.service";
import {TpiqCustomDatepicker} from "../../../directives/tpiq-custom-datepicker";
import { TaxPlanningService } from '../../../../app/tpiq-services/tax-planning.service';
import { environment } from '../../../../environments/environment';

declare const _: any;

@Component({
  selector: 'app-task-todos',
  standalone: true,
  imports: [CommonModule, FormsModule, TrackerPaginatedTableComponent, TpiqCustomDatepicker],
  templateUrl: './task-todos.component.html',
  styleUrl: './task-todos.component.scss'
})
export class TaskTodosComponent implements OnInit, OnDestroy {
  tableData: any = {};
  routeSubscribe: any;
  hasNextPage = true;
  isLoading = false;
  toDosTableData: any = {};
  toDosTableColumns: any;
  todoSort: any = {};
  hasToDos = false;
  selectedPlanId: string = 'all';
  isCustomer = false;
  hasNextSet = false;
  index = 0;
  org = '';
  user = '';
  clientId = '';
  companyId = '';
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  showTable = true;
  dateFormat: string;
  serviceDateformat: string;
  toDosForm: FormGroup;
  recurringFrequencies: Array<any> = [{key: 'Never', value: 'Never'}, {key: 'Weekly', value: 'Weekly'},
    {key: 'Bi Weekly', value: 'Bi Weekly'}, {key: 'Monthly', value: 'Monthly'}, {
      key: 'Bi Monthly',
      value: 'Bi Monthly'
    },
    {key: 'Semi Monthly', value: 'Semi Monthly'}, {key: 'Quarterly', value: 'Quarterly'}, {
      key: 'Half Yearly',
      value: 'Semi Yearly'
    },
    {key: 'Yearly', value: 'Yearly'}];
  dueDateTypes: Array<any> = [{key: 'This Week', value: 'This Week'}, {
    key: 'Next Week',
    value: 'Next Week'
  }, {key: 'In Number of Weeks', value: 'In Number of Weeks'}, {key: 'This Month', value: 'This Month'},
    {key: 'Next Month', value: 'Next Month'}, {
      key: 'In Number of Months',
      value: 'In Number of Months'
    }, {key: 'This Quarter', value: 'This Quarter'}, {key: 'Next Quarter', value: 'Next Quarter'},
    {key: 'In Number of Quarters', value: 'In Number of Quarters'}, {
      key: 'This Year',
      value: 'This Year'
    }, {key: 'Next Year', value: 'Next Year'}, {key: 'In Number of Years', value: 'In Number of Years'}];
  dayNames: Array<any> = [{name: 'Sun'}, {name: 'Mon'}, {name: 'Tue'}, {name: 'Wed'}, {name: 'Thu'}, {name: 'Fri'}, {name: 'Sat'}];
  monthNames: Array<any> = [{name: 'Jan'}, {name: 'Feb'}, {name: 'Mar'}, {name: 'Apr'}, {name: 'May'}, {name: 'Jun'}, {name: 'Jul'}, {name: 'Aug'}, {name: 'Sep'}, {name: 'Oct'}, {name: 'Nov'}, {name: 'Dec'}];
  daysInMonth: Array<any> = [];
  quarters: Array<any> = [{key: 'Month 1', value: 'Month 1'}, {key: 'Month 2', value: 'Month 2'}, {
    key: 'Month 3',
    value: 'Month 3'
  }];
  recurringDuedateTypes = {
    Weekly: [{key: 'This Week', value: 'This Week'}, {key: 'Next Week', value: 'Next Week'},
      {key: 'In Number of Weeks', value: 'In Number of Weeks'}],
    Monthly: [{key: 'This Month', value: 'This Month'}, {key: 'Next Month', value: 'Next Month'},
      {key: 'In Number of Months', value: 'In Number of Months'}],
    Quarterly: [{key: 'This Quarter', value: 'This Quarter'}, {key: 'Next Quarter', value: 'Next Quarter'},
      {key: 'In Number of Quarters', value: 'In Number of Quarters'}],
    Yearly: [{key: 'This Year', value: 'This Year'}, {key: 'Next Year', value: 'Next Year'},
      {key: 'In Number of Years', value: 'In Number of Years'}],
  };
  periodDropdown: any = {
    Weekly: false,
    Monthly: false,
    Quarterly: false,
    Yearly: false,
    Duration: false
  };
  triggerperiodDropdown: any = {
    Weekly: false,
    Monthly: false,
    Quarterly: false,
    Yearly: false,
    Duration: false
  };
  clearDuedateTypes = false;
  editMode = false;
  searchString: string;
  preferredStatuses: Array<any> = [{id: 'Assigned', name: 'Assigned'}, {id: 'Done', name: 'Done'}];
  type = '';
  currentTodoId: string;
  currentPost: any;
  showPost: boolean;
  currentTodo: any;
  todoStatus = 'Assigned';
  priorities: Array<any> = [{id: 'High', name: 'High', badge: 'H'}, {
    id: 'Medium',
    name: 'Medium',
    badge: 'M'
  }, {id: 'Low', name: 'Low', badge: 'L'}];

  uploader: FileUploader;
  attachments: Array<any> = [];
  billUploadResp: any;
  document: any;
  storedAttachments: Array<any> = [];
  hasBaseDropZoneOver = false;
  @Input() isTaxPlanningTask: boolean;

  @Input()
  set trackerSinglePageData(data) {
    this.type = 'tracker-singlePage';
    this.buildToDosTableData(data, true);
  }

  @Input() taskId;
  channelId = '';
  channelType = '';
  todoId: any;
  userId: string;
  @Input() isClientInfo;
  editorOptions = {
    heightMin: 150,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'insertLink', 'outdent', 'indent'],
    toolbarSticky: true,
    toolbarVisibleWithoutSelection: false,
    toolbarInline: true,
    fontFamilySelection: true,
    placeholderText: 'Description...',
    charCounterCount: false,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    events: {},
    key: environment.froalaKey,
    pasteDeniedAttrs: ['class', 'id', 'style'],
    imageUploadRemoteUrls: false,
    quickInsertEnabled: false,
    quickInsertTags: [],
  };
  postTemplates: Array<any> = [];
  togglePostTemplate = false;
  externalUsers: Array<any> = [];
  clientExternalUsers: Array<any> = [];
  firmTodoId = '';
  showAssignees = true;
  todoData: any;
  clientPlanOptions:any;
  
  constructor(
    private _fb: FormBuilder,
    private _router: Router,
    private clientTodoService: TodoServices,
    private loadingService: LoadingService,
    private titleService: PageTitleService,
    private stateService: StateService,
    private dateFormater: DateFormater,
    private changeDetectorRef: ChangeDetectorRef,
    private switchBoard: SwitchBoard,
    private toastService: ToastService,
    private collaborationService: CollaborationService,
    private _route: ActivatedRoute,
    private _toastService: ToastService,
    private tasksService: TasksService,
    private todoService: TpFirmTodoService,
    private taxV2PlanningService: TaxPlanningService) {

    this.switchBoard.onToastConfirm
      .pipe(takeUntil(this.destroy$))
      .subscribe(toast => {
        if (toast.data.deleteType && toast.data.deleteType === 'deleteTodo') {
          this.deleteTodo(toast.data);
        }
      });
  }

  ngOnInit(): void {
    this.isCustomer = Session.getUser().isCustomer;
    this._route.params.pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        this.checkParams(params);
        this._init();
      });
  }

  checkParams(params) {
    if (params.channelId) {
      this.channelId = params.channelId;
      this.channelType = params.channelType;
    }
    if (params && params.type) {
      this.type = params.type;
    } else if (params && params.id) {
      this.currentTodoId = params.id;
      this.type = 'singlePage';
    }
    if (params && params.firmTodoId) {
      this.firmTodoId = params.firmTodoId;
    }
  }

  getClientPlans(){
        const clientInfo: any = Session.getClient(); 
        this.loadingService.triggerLoadingEvent(true);
        this.taxV2PlanningService.getAllClientPlans(this.user, this.org,clientInfo?.qountClientId).subscribe(response => {
            this.loadingService.triggerLoadingEvent(false);  
            this.clientPlanOptions=response?.planList;
            
        }, error => {
            this.loadingService.triggerLoadingEvent(false);
            try {
                const message = JSON.parse(error).message || 'Failed To get All Plans';
                this._toastService.pop(TOAST_TYPE.error, message);
            } catch (err) {
                this._toastService.pop(TOAST_TYPE.error, 'Failed To get All Plans');
            }
        });
    }

  _init() {
    this.org = Session.getOrg();
    this.userId = Session.getUser().id;
    this.user = Session.getUser('delegatedFrom').id;
    this.dateFormat = this.dateFormater.getFormat();
    this.serviceDateformat = this.dateFormater.getServiceDateformat();
    if (this.type !== 'tracker-singlePage') {
      if (this.type !== 'all') {
        if (!this.isClientInfo) {
          this.titleService.setPageTitle(`Todo's`);
        }
        this.clientId = Session.getConversation().client_id;
        this.companyId = Session.getConversation().id;
      } else if (!this.isClientInfo) {
        this.titleService.setPageTitle(`Todo's`);
      }
      if (this.currentTodoId) {
        this.getTodo();
      } else {
        this.showTodos('Assigned');
      }
    }

    this.switchBoard.onClickPrev
      .pipe(takeUntil(this.destroy$))
      .subscribe(title => {
        if (!this.showTable) {
          if (!this.isClientInfo) {
            this.titleService.setPageTitle(`Todo's`);
          }
          this.showTable = true;
          this.stateService.pop();
        } else {
          this.gotoDefaultPage();
        }
      });
    if (this.type !== 'tracker-singlePage') {
      this.switchBoard.onClearSearch.next({});
    }
    this.getClientPlans();
  }

  showTodos(status) {
    this.todoStatus = status;
    this.index = 0;
    this.getAllToDos(this.todoStatus);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  gotoDefaultPage() {
    const prevState = this.stateService.getPrevState();
    if (prevState && prevState.url) {
      prevState.url = prevState.url.split('(')[0];
    }
    if (prevState && prevState.key === 'firm-todos') {
      this._router.navigate([prevState.url]);
    } else if (prevState) {
      this.stateService.pop();
      this._router.navigate([prevState.url]);
    }
  }

  getAllToDos(status) {
     let planId = this.selectedPlanId == 'all'? '': this.selectedPlanId;
    this.loadingService.triggerLoadingEvent(true);
    const base = this;
    let request;
    request = {
      fromIndex: this.index,
      searchKey: ''
    };
    const clientInfo: any = Session.getClient();
    this.clientTodoService.getAllTodosTableData(this.org, this.user, this.channelType, this.channelId, status, request, this.type, clientInfo)
      .subscribe(response => {
        this.hasNextPage = response.hasNextPage;
        this.index += response.toDosList.length;
        this.buildToDosTableData(response || [], true);
        this.loadingService.triggerLoadingEvent(false);
      }, error => {

        const message = error.message || `Failed To Get ToDo's`;
        this.toastService.pop(TOAST_TYPE.error, message);
        this.loadingService.triggerLoadingEvent(false);
      });
  }

  getTodo() {
    this.loadingService.triggerLoadingEvent(true);
    const base = this;
    const withPost = true;
    this.clientTodoService.getTodoTableData(this.user, this.org, this.currentTodoId, withPost)
      .subscribe(response => {
        this.hasNextPage = response.hasNextPage;
        this.index += response.toDosList.length;
        this.attachments = response.documents;
        this.currentTodo = response.toDosList[0];
        if (response.post) {
          this.createdPost(JSON.parse(response.post));
        } else {
          this.showPost = true;
        }
        this.buildToDosTableData(response || [], true);
        this.loadingService.triggerLoadingEvent(false);
      }, error => {

        const message = error.message || `Failed To Get ToDo's`;
        this.toastService.pop(TOAST_TYPE.error, message);
        this.loadingService.triggerLoadingEvent(false);
      });
  }

  handleScroll(event: NgxScrollEvent) {
    // const base = this;
    // if (event.isReachingBottom && !base.isLoading && !event.isWindowEvent && this.hasNextPage) {
    //     base.isLoading = true;
    //     this.getAllToDos(this.todoStatus);
    // }
  }

  handleAction($event) {
    if ($event.action === 'edit') {
      this.checkToDoEdit($event);
    } else if ($event.action === 'delete') {
      this.removeTodo($event);
    } else if ($event.action === 'collaboration') {
      this.navigateToTodo($event);
    } else if ($event.action === 'status') {
      this.moveNextStatus($event);
    }else if ($event.action === 'open-todos-side-modal'){
            this.loadingService.triggerLoadingEvent(true);
            this._router.navigate(
                [
                  {
                    outlets: {popup: ['client-single-todo','clients',$event.clientId,'toDo',$event.id]}
                  }
                ]
              );
              

        }
  }

  checkToDoEdit($event) {
    if (this.type === 'all') {
      this.titleService.setPageTitle('Edit Todo');
      this.editMode = true;
      this.channelType = 'clients';
      this.channelId = $event.clientId;
      this.navigateToTodo($event);
    } else if (this.type !== 'singlePage') {
      this.navigateToTodo($event);
    }
  }

  removeTodo($event) {
    $event.deleteType = 'deleteTodo';
    this.toastService.pop(TOAST_TYPE.confirm, 'Are you sure you want to delete?', $event);
  }

  navigateToTodo(todo) {
    this.channelType = 'clients';
    this.channelId = todo.clientId;
    this.stateService.addState(new State('todos', this._router.url, null, null));
    this._router.navigate([this.channelType, this.channelId, 'toDo', todo.id, 'singlepage']);
  }


  deleteTodo(todo) {
    this.loadingService.triggerLoadingEvent(true);
    this.clientTodoService.removeToDo(this.org, this.user, this.channelId, todo.id)
      .subscribe(response => {
        this.showTable = true;
        _.remove(this.toDosTableData, {id: todo.id});
        const index = _.findIndex(this.tableData.rows, {id: todo.id});
        if (index !== -1) {
          this.tableData.rows.splice(index, 1);
          const rows = this.tableData.rows || [];
          this.tableData = {...this.tableData, rows};
        }
        this.toastService.pop(TOAST_TYPE.success, 'ToDo Deleted Successfully');
        this.loadingService.triggerLoadingEvent(false);
      }, error => {

        const message = error.message || 'Failed To Delete ToDo';
        this.toastService.pop(TOAST_TYPE.error, message);
        this.loadingService.triggerLoadingEvent(false);
      });
  }

  sortByColumn($event) {
    this.index = 0;
    this.sortToDos($event);
  }

  buildToDosTableData(data, refreshStatus?) {
    const base = this;
    this.isLoading = false;
    this.toDosTableData = data.toDosList || [];
    // this.toDosTableColumns = data.columns;
    const todos = data.toDosList || [];
    this.hasNextSet = data.hasNextPage;
    refreshStatus = refreshStatus === undefined ? true : refreshStatus;
    this.buildTable(todos, refreshStatus);
  }

  buildTable(data, refreshTable?) {
    const base = this;
    this.tableData.options = {
      height: '75vh',
      selectorString: 'id',
      showSearch: false,
      searchString: this.searchString
    };
    this.tableData.columns = [];
    if (base.type === 'tracker-singlePage') {
      this.tableData.columns.push({
        name: 'title',
        title: 'Title',
        type: 'html',
        classes: 'pointer',
        sortable: false
      });
      this.tableData.columns.push({
        name: 'description',
        title: 'Description',
        type: 'html',
        classes: 'pointer',
        sortable: false
      });
      this.tableData.columns.push({
        name: 'dueDate',
        title: 'Due Date',
        type: 'date',
        format: 'MM/DD/YYYY',
        placeholder: 'MM/DD/YYYY',
        classes: 'input-date pointer',
        sortable: true
      });
      this.tableData.columns.push({
        name: 'priority',
        title: 'Priority',
        type: 'badge-input-search',
        displayName: 'badge',
        full_name: 'name',
        background: 'colorCode',
        'multi-dropdown': false,
        data: base.priorities,
        placeholder: '',
        classes: 'input-search pointer',
        sortable: true
      });
    }else if(base.type === 'all'){
            this.tableData.columns.push({
                name: 'title',
                title: 'Title',
                type: 'html',
                showTooltip: true,
                classes: 'pointer',
            });
            this.tableData.columns.push({
                name: 'planName',
                title: 'Plan Name',
                type: 'html',
                showTooltip: true,
                classes: 'pointer',
            });
            this.tableData.columns.push({
                name: 'description',
                title: 'Description',
                type: 'html',
                showTooltip: false,
                classes: 'pointer',
            });
            this.tableData.columns.push({
                name: 'status',
                title: 'Status',
                type: 'html',
                classes: 'pointer',
            });
            this.tableData.columns.push({
                name: 'priority',
                title: 'Priority',
                type: 'html',
              
            });
            this.tableData.columns.push({
                name: 'dueDate',
                title: 'Due Date',
                type: 'html',
                classes: 'pointer',
                sortable: true
            });
      } else {
      this.tableData.columns.push({
        name: 'clientName',
        title: 'Client',
        type: 'html',
        classes: 'pointer',
        sortable: true
      });
      this.tableData.columns.push({
        name: 'status',
        title: 'Status',
        type: 'html',
        classes: 'pointer',
        sortable: true
      });
      this.tableData.columns.push({
        name: 'dueDate',
        title: 'Due Date',
        type: 'html',
        classes: 'pointer',
        sortable: true
      });
      this.tableData.columns.push({
        name: 'title',
        title: 'Title',
        type: 'html',
        showTooltip: true,
        classes: 'pointer',
        sortable: true
      });
      this.tableData.columns.push({
        name: 'description',
        title: 'Description',
        type: 'html',
        showTooltip: false,
        classes: 'pointer',
        sortable: true
      });
    }
    this.tableData.columns.push({
      name: 'actions',
      classes: 'overflow-css',
      title: '',
      type: 'html',
      sortable: false
    });

    if (refreshTable) {
      this.tableData.rows = [];
    } else {
      this.tableData.rows = this.tableData.rows || [];
    }
    const rows = base.tableData.rows || [];
    data.forEach(function(todo) {
      const row = base.createTableRow(todo);
      rows.push(row);
    });
    this.tableData = {...this.tableData, rows};
    this.handleSortOrder(this.todoSort, this.tableData.columns);
    if (refreshTable) {
      this.hasToDos = false;
    }
    this.loadingService.triggerLoadingEvent(false);

    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
    if (base.tableData.rows.length > 0) {
      base.isLoading = false;
    } else {
      base.isLoading = false;
    }
    base.hasToDos = true;
  }

  formatColumnsForTable(data) {
    const base = this;
    const colsArray = [];
    let orderArray;
    if (typeof data !== 'string') {
      orderArray = data;
    } else {
      orderArray = JSON.parse(data);
    }

    if (this.isClientInfo) {
      orderArray = {
        Title: 'title',
        'Due Date': 'dueDate',
        Status: 'status'
      };
    }

    _.each(Object.keys(orderArray), function(key) {
      if (base.type === 'tracker-singlePage') {
        if (key === 'Title') {
          colsArray.push({
            name: orderArray[key],
            title: key,
            type: 'html',
            classes: 'pointer zero-overflow tracker-single-title',
            sortable: false
          });
        } else if (key === 'Status') {
          colsArray.push({
            name: orderArray[key],
            title: key,
            type: 'html',
            classes: 'pointer',
            sortable: false
          });
        } else if (key === 'Due Date') {
          colsArray.push({
            name: orderArray[key],
            title: key,
            type: 'date',
            format: 'MM/DD/YYYY',
            placeholder: 'MM/DD/YYYY',
            classes: 'input-date pointer',
            sortable: true
          });
        } else if (orderArray[key] === 'priority') {
          colsArray.push({
            name: 'priority',
            title: 'Priority',
            type: 'badge-input-search',
            displayName: 'badge',
            full_name: 'name',
            background: 'colorCode',
            'multi-dropdown': false,
            data: base.priorities,
            placeholder: 'Priority',
            classes: 'input-search pointer',
            sortable: true
          });
        } else {
          colsArray.push({name: orderArray[key], title: key, type: 'normal', sortable: false});
        }
      } else {
        if (key === 'Client') {
          colsArray.push({
            name: orderArray[key],
            title: key,
            type: 'html',
            classes: 'pointer zero-overflow',
            sortable: true
          });
        } else if (key === 'Status') {
          colsArray.push({
            name: orderArray[key],
            title: key,
            type: 'html',
            classes: 'pointer',
            sortable: true
          });
        } else if (key === 'Due Date') {
          colsArray.push({
            name: orderArray[key],
            title: key,
            type: 'html',
            classes: 'pointer',
            sortable: true
          });
        } else if (key === 'Title') {
          colsArray.push({
            name: orderArray[key],
            title: key,
            type: 'html',
            showTooltip: true,
            classes: 'tracker-desc pointer',
            sortable: true
          });
        } else if (key === 'Description') {
          colsArray.push({
            name: orderArray[key],
            title: key,
            type: 'html',
            showTooltip: false,
            classes: 'pointer',
            sortable: true
          });
        } else if (key === 'Assignees') {
          colsArray.push({
            name: orderArray[key],
            title: key,
            type: 'badge-input-search',
            displayName: 'badge',
            full_name: 'name',
            background: 'colorCode',
            'multi-dropdown': true,
            placeholder: 'Assignee',
            classes: 'input-search pointer',
            sortable: false,
            dropdownData: 'externalUsers'
          });
        } else {
          colsArray.push({name: orderArray[key], title: key, type: 'normal', sortable: true});
        }
      }
    });
    return colsArray;
  }

  createTableRow(todo) {
    const base = this;
    const row: any = {};
    const tooltipClass = base.getTooltipHtmlClass();
    _.each(todo, function(value, key) {
      if(base.type === 'all'){
                if(key === 'title'){
                    row[key] = `<a class='actionOnId' data-action='open-todos-side-modal'>${todo[key]}</a>`;                 
                }else if(key === 'priority'){
                    row[key] = `<span class='name_badge ${"name_badge_"+todo.priority}'>
                                <span class='badge-tooltip pointer'> ${todo.priority}
                                </span></span>`;
                }else{
                    row[key] = todo[key];
                }         
            }else{
      if (key === 'title' && base.type === 'tracker-singlePage') {
        row.name = todo[key];
        row[key] = `<a class='actionOnId' data-action='edit'><span class='icon title-name'>${base.setClientTitleString(todo)}</span></a>`;
        // row[key] = `<a class='actionOnId' data-action='edit'><span class='icon badge-tooltip title-name'>${base.setClientTitleString(todo)}<span class='${tooltipClass} clientTooltip'>${todo[key]}</span></span></a>`;
      } else if (key === 'clientName') {
        row[key] = `<a class='actionOnId' data-action='edit'>${todo[key]}</a>`;
        row.name = todo[key];
      } else if (key === 'dueDate' && base.type !== 'tracker-singlePage') {
        row[key] = `<a class='actionOnId' data-action='collaboration'>${todo[key]}</a>`;
      } else if (key === 'status' && base.type !== 'tracker-singlePage') {
        row[key] = `<a class='actionOnId' data-action='collaboration'>${todo[key]}</a>`;
      } else if (key === 'title' && base.type !== 'tracker-singlePage') {
        row[key] = `<a class='actionOnId' data-action='collaboration'><span class='icon title-name'>${base.setClientTitleString(todo)}</span></a>`;
        // row[key] = `<a class='actionOnId' data-action='collaboration'><span class='icon badge-tooltip title-name'>${base.setClientTitleString(todo)}<span class='${tooltipClass} clientTooltip'>${todo[key]}</span></span></a>`;
      } else if (key === 'description' && base.type !== 'tracker-singlePage') {
        row[key] = `<a class='actionOnId' data-action='collaboration'>${todo[key]}</a>`;
      } else {
        row[key] = todo[key];
      }
    }
    });
    let status = '';
    let del = `<a class='action' data-action='delete'><span class='todo-del'><i class='material-icons delete'>delete</i></span></a>`;

    if (todo.priority && base.type !== 'all') {
      row.actions = `<span class='name-badge' style='position:relative;right:10px;background-color: ${base.getPriorityColor(todo.priority)}'>
                                <span class='badge-tooltip pointer'> ${base.getPriorityBadge(todo.priority)}
                                <span class='topTooltiptext'> ${base.getPriorityToolTipName(todo.priority)} </span></span></span>`;
    } else {
      row.actions = '';
    }
    /*let postString = `<a class='action' data-action='collaboration'><span class='comment-badge'><div class='material-icons mdl-badge tracker-badge last-activity' style='color: rgb(128, 128, 128)' data-badge=''>comment</div></span></a>`;
    if (todo.postlastActivity) {
        postString = `<a class='action' data-action='collaboration'><span class='comment-badge'><div class='material-icons tracker-badge' style='color: rgb(128, 128, 128)' data-badge=''>comment</div></span></a>`;
    }
    row.actions += postString;
    */
    if(base.type !== 'all'){
    if (todo.status.toLocaleLowerCase() === 'done') {
      status = `<a class='action' data-action='status'> <span class='status_move_done'><i class='material-icons'>done</i></span></a>`;
    } else {
      status = `<span class='badge-tooltip'><a class='action' data-action='status'><span class='next-status'><i class='material-icons'>done</i><span class='bottomTooltiptext' style='font-size: 13px !important;width: 100px !important;left: 25px !important;'>Mark Done</span></span></a></span>`;
    }
  }
    row.actions += status;
    if (!Session.getUser().isCustomer) {
      row.actions += del;
    }
    row.isEditable = false;
    return row;
  }

  setClientTitleString(todo) {
    if (todo && todo.title && todo.title.length > 20) {
      return todo.title.substring(0, 20) + '....';
    } else {
      return todo.title;
    }
  }

  getPriorityColor(status) {
    let color = '#0AA8E2';
    switch (status) {
      case 'High':
        color = '#f1645a';
        break;
      case 'Low':
        color = '#5376E3';
        break;
      case 'Medium':
        color = '#0AA8E2';
        break;
    }
    return color;

  }

  getPriorityBadge(priority) {
    if (priority) {
      const firstletter = priority ? priority.charAt(0) : '';
      return firstletter;
    }
    return '';
  }

  getPriorityToolTipName(prior) {
    if (prior) {
      const firstletter = prior ? prior : '';
      return firstletter;
    }
    return '';
  }

  getTooltipHtmlClass() {
    return this.tableData.rows && this.tableData.rows.length === 0 ? 'bottomTooltiptext' : 'topTooltiptext';
  }


  sortToDos(obj) {
    this.todoSort[obj.column] = obj.order;
    this.resetSortOrder(this.todoSort, this.tableData.columns, obj.column);
    const request = {
      fromIndex: this.index,
      searchKey: this.searchString,
      sortKey: obj.column,
      sortOrder: obj.order,
    };
    this.loadingService.triggerLoadingEvent(true);
    this.getData(request);
  }

  resetSortOrder(sortOrder, columns, column) {
    _.each(columns, function(col) {
      if (col.name !== column) {
        sortOrder[col.name] = '';
      }
    });
  }

  handleSortOrder(tasksSortOrder, columns) {
    _.each(columns, function(column) {
      column.sortType = tasksSortOrder[column.name];
    });
  }


  getData(obj) {
    this.clientTodoService.getAllTodosTableData(this.org, this.user, this.channelType, this.channelId, this.todoStatus, obj, this.type)
      .subscribe(response => {
        this.buildToDosTableData(response, true);
      });
  }

  createdPost(post) {
    this.currentTodo.postId = post.id;
    this.currentPost = post;
    this.showPost = true;
  }

  handleRowAction($event) {
    this.navigateToTodo($event);
  }

  moveNextStatus($event) {
    const base = this;
    const data = _.find(this.toDosTableData, {id: $event.id});
    data.checked = true;
    data.status = (data.status && data.status.toLowerCase() == 'assigned') ? 'Done' : 'Assigned';
    let obj = {};
    obj['id'] = data.id;
    obj['action'] = 'singleUpdate';
    obj['actedOn'] = 'status';
    obj['value'] = data.status;
    obj['ids'] = [];
    this.loadingService.triggerLoadingEvent(true);
    this.todoService.updateFirmTodoStatus(this.org, this.user, obj)
      .subscribe(response => {
        base.switchBoard.onUpdateStatusToDo.next({});
        if (base.type === 'tracker-singlePage') {
          const index = _.findIndex(this.tableData.rows, {id: $event.id});
          const rows = this.tableData.rows || [];
          rows[index] = this.createTableRow(data);
          this.tableData = {...this.tableData, rows};
          this.toDosTableData[index] = data;
        } else {
          _.remove(this.toDosTableData, {id: $event.id});
          const index = _.findIndex(this.tableData.rows, {id: $event.id});
          if (index !== -1) {
            this.tableData.rows.splice(index, 1);
            const rows = this.tableData.rows || [];
            this.tableData = {...this.tableData, rows};
          }
        }
        this.toastService.pop(TOAST_TYPE.success, 'Status Updated Successfully');
        this.loadingService.triggerLoadingEvent(false);
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        if ($event.column) {
          this.toastService.pop(TOAST_TYPE.error, 'Failed To Update Status');
        }
      });
  }

  updateInput(obj) {
    const base = this;
    const todo = _.find(this.toDosTableData, {id: obj.row.id});
    if (todo) {
      if (todo[obj.column]) {
        todo[obj.column] = obj.row[obj.column];
      } else if (obj.row[obj.column]) {
        todo[obj.column] = obj.row[obj.column];
      }
      todo.dueDate = todo.dueDate ? this.dateFormater.formatDate(todo.dueDate, base.dateFormat, base.serviceDateformat) : '';
      this.clientTodoService.updateSinglePageTodo(this.org, this.user, this.taskId, todo)
        .subscribe(response => {
          const index = _.findIndex(this.tableData.rows, {id: obj.row.id});
          if (index !== -1) {
            const rows = this.tableData.rows || [];
            rows[index] = this.createTableRow(response);
            this.tableData = {...this.tableData, rows};
            this.toDosTableData[index] = response;
          }
          this.toastService.pop(TOAST_TYPE.success, 'Due Date Updated Successfully');
        }, error => {
          this.toastService.pop(TOAST_TYPE.error, 'Failed To Update Due Date');
        });
    }
  }

  optionSelected($event) {
    if ($event.column === 'toDoAssignee') {
      let data = {};
      if ($event.column && $event.multiDropdown && $event.type === 'add') {
        data = {
          id: $event.row.id,
          action: 'updateAssignee',
          actedOn: 'assignee',
          value: $event.entry.assignedTo,
          ids: []
        };
      } else if ($event.column && $event.multiDropdown && $event.type === 'remove') {
        data = {
          id: $event.row.id,
          action: 'removeAssignee',
          actedOn: 'assignee',
          value: $event.entry.assignedTo,
          ids: []
        };
      }
      this.clientTodoService.updateFirmTodoData(this.org, this.userId, data)
        .subscribe(response => {
          const index = _.findIndex(this.tableData.rows, {id: $event.row.id});
          if (index !== -1) {
            const rows = this.tableData.rows || [];
            rows[index].toDoAssignee = response.assignees;
            this.tableData = {...this.tableData, rows};
            this._toastService.pop(TOAST_TYPE.success, 'Assignees Updated Successfully');
          }
        }, error => {
          this.loadingService.triggerLoadingEvent(false);
          this._toastService.pop(TOAST_TYPE.error, 'Failed To Update Assignees');
        });
    }
  }

}
